import { render, staticRenderFns } from "./CalendarComponent.vue?vue&type=template&id=1ed5785c&scoped=true&"
import script from "./CalendarComponent.vue?vue&type=script&lang=js&"
export * from "./CalendarComponent.vue?vue&type=script&lang=js&"
import style0 from "./CalendarComponent.vue?vue&type=style&index=0&id=1ed5785c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed5785c",
  null
  
)

export default component.exports